export type ChatRole = "user" | "assistant";
export type ChatMessage = { role: ChatRole; content: string };

type ChatResponse = { reply?: string; content?: string };

/**
 * POST the conversation to the AI chat control-plane backend and return
 * the assistant's reply text.
 *
 * `credentials: "include"` so the parent-domain session cookie
 * (CPF-NFR-026) authenticates the caller cross-origin — the chat backend
 * lives once (prod / control plane, CPF-NFR-033) and is reached from any
 * env's portal. The chat is READ-ONLY over the knowledge base; this
 * client sends only the message transcript, never any mutation.
 */
export const sendChatMessage = async (
  apiUrl: string,
  messages: ChatMessage[],
): Promise<string> => {
  const res = await fetch(apiUrl, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages }),
  });

  if (!res.ok) {
    throw new Error(`Chat request failed (${res.status})`);
  }

  const data = (await res.json()) as ChatResponse;
  return data.reply ?? data.content ?? "";
};
